import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import View from 'view/base';
import View_Menu from 'page/account/menu';
import View_Workspace_Settings from 'view/workspace/general_settings';

export default View.extend({
    tagName: 'section',

    views: {
        menu: {},
        workspace_settings: {}
    },

    initialize: function() {
        this.views.menu = new View_Menu();
        this.views.workspace_settings = new View_Workspace_Settings({model: Cache.getDefaultWorkspace()});
    },

    render: function() {
        UI.setPageTitle('Workspace Settings');

        var content =
        '<main class="xlarge">' +
            '<div class="region-workspace-settings"></div>' +
        '</main>';

        this.$el.html(content);

        this.views.menu.render().$el.prependTo(this.$el.find('main'));
        this.views.workspace_settings.render().$el.appendTo(this.$el.find('.region-workspace-settings'));

        return this;
    }
});